export default __webpack_public_path__ + "static/media/IMG_9388.617a1968.JPG";